import { createStore, applyMiddleware, combineReducers, compose } from 'redux'
import { thunk } from 'redux-thunk'
import { createLogger } from 'redux-logger'
import _ from 'underscore'
import reducers from '../reducers'
import { routerMiddleware } from 'react-router-redux'
import browserHistory from '../common/history'
// import process from 'process';

const logger = createLogger()
let composeEnhancers = compose
const routerMiddleWare = routerMiddleware(browserHistory)
let middleware
if (
    process.env.APP_ENV.includes('dev') ||
    process.env.APP_ENV.includes('test')
) {
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
}
if (process.env.APP_ENV.includes('live')) {
    middleware = [applyMiddleware(thunk, routerMiddleWare)]
} else {
    middleware = [applyMiddleware(thunk, routerMiddleWare)]
    // middleware = [applyMiddleware(thunk, routerMiddleWare)]
}

export default function configureStore(additionalReducers = {}) {
    const store = createStore(
        combineReducers({ ...reducers, ...additionalReducers }),
        {},
        composeEnhancers(...middleware)
    )

    return store
}
